import React from 'react'
import InputSelector from '../inputselector/InputSelector'
import newhome from '../../assets/images/new-home-left.png'
import studentDriver from '../../assets/images/student-driver.png'
import { Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'

export const GetRoadHome = ({heading,sub_heading,content,button}) => {
  return (
    <section className="keyzi_conquer--wrapper keyzi_getroadNew--wrapper" id="find-instructor">
      <div className="container">
        <div className="keyzi_conquer--inner">
          <div className="row">
            <div className="col-md-6">
              <div className="left-side">
              <h3>{heading || "We'll Help Get Your Licence"}</h3>
              <p>{sub_heading || "Find Driving Lessons"}</p>
            
            <InputSelector/>
              </div>
            </div>
            <div className="col-md-6 mt-3 mt-md-0">
              <div className="right-side">
                 <img src={ content?.[0]?.image ? "https://keyzi.com.au/keyzi-admin/public" + content?.[0]?.image : studentDriver}  alt={content?.[0]?.image_attribute} className='img-fluid'/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
